var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevlights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2048,
    height: 2048,
    viewBox: "0 0 541.867 541.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9800",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7d91",
      stopOpacity: 0.99633199
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 34.34,
    x2: 234.724,
    y1: 135.636,
    y2: 135.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9800",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7d91",
      stopOpacity: 0.99633199
    }
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.507,
    cy: 104.69,
    rx: 2.462,
    ry: 4.522,
    style: {
      fill: "none",
      strokeWidth: 0.529166
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.377,
    cy: 109.272,
    rx: 3.41,
    ry: 7.83,
    style: {
      fill: "none",
      strokeWidth: 0.529166
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.515,
    cy: 111.276,
    rx: 4.049,
    ry: 5.296,
    style: {
      fill: "none",
      strokeWidth: 0.529166
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.28629 0 0 2.28629 -38.934 -20.049)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134.532,
    cy: 135.636,
    r: 100.192,
    style: {
      fill: "url(#b)",
      fillOpacity: 1,
      stroke: "#ff9800",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 106.03,
    height: 25.245,
    x: 81.193,
    y: 142.084,
    ry: 12.623,
    style: {
      fill: "#333",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.237,
    cy: 74.373,
    r: 60.115,
    style: {
      fill: "#333",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.685 35.774a18.698 18.698 0 0 0 .04 37.396h11.687v38.094l7.012.155V73.17h16.802v38.245l7.011.054V73.17h11.687v.007a18.698 18.698 0 1 0-18.697-18.701h-.001v11.682h-16.802v-11.74a18.698 18.698 0 0 0-18.739-18.644zm.028 7.012h.012c6.454 0 11.686 5.232 11.686 11.686h.001v11.686h-11.687c-6.454 0-11.686-5.232-11.686-11.686 0-6.449 5.225-11.68 11.674-11.686zm54.211.007c6.455 0 11.687 5.232 11.687 11.686 0 6.438-5.208 11.664-11.646 11.686v-.007h-11.728V54.48h.001c0-6.454 5.232-11.686 11.686-11.686z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#1de9b6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 7.0117,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.482,
    height: 9.316,
    x: 103.639,
    y: 108.735,
    ry: 4.658,
    style: {
      fill: "#4d4d4d",
      fillOpacity: 1,
      stroke: "#333",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80.785,
    height: 25.245,
    x: 91.291,
    y: 179.952,
    ry: 12.623,
    style: {
      fill: "#333",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.589,
    height: 25.245,
    x: 101.389,
    y: 217.82,
    ry: 12.623,
    style: {
      fill: "#333",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevlights);
export default __webpack_public_path__ + "static/media/devlights.a16a8c88a1d02968e9dedf1181153f12.svg";
export { ForwardRef as ReactComponent };